import React, { memo, useMemo } from 'react';
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, ImageSizeTokens, SizeTypeTokens, } from '@voltmoney/schema';
import { ScrollView, Text, View } from "react-native";
import { isMobileView } from "../stack/utils";
import { Space } from "../space/Space";
import { Button } from "../button/Button";
import { Image } from "../image/Image";
import ThemeProvider from "@voltmoney/theme";
/**
 * Primary UI component for user interaction
 */
const PartnerPromotionCards = ({ data }) => {
    const _isMobile = isMobileView();
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const renderCardItems = useMemo(() => (React.createElement(View, { style: {
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
        } }, data?.map((item, index) => (React.createElement(React.Fragment, null,
        React.createElement(View, { style: {
                display: 'flex',
                flexDirection: 'row',
                padding: _isMobile ? 12 : 24,
                flex: 1,
                ...(_isMobile && data?.length > 1) && {
                    maxWidth: 330
                },
                ...(!_isMobile && data?.length > 1) && {
                    maxWidth: 650
                },
                alignItems: 'center',
                backgroundColor: item?.backgroundColor || '#FFFFF',
                borderRadius: 8
            } },
            React.createElement(View, { style: {
                    // width: _isMobile
                    //         ? 180
                    //         : data?.length === 1
                    //         ? 400
                    //         : 270,
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-evenly',
                    height: '100%'
                } },
                React.createElement(View, { style: {
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                    } },
                    item?.title &&
                        React.createElement(React.Fragment, null, _isMobile ? (
                        //@ts-ignore
                        React.createElement(Text, { style: {
                                fontSize: item?.titleFontSizeMobile
                                    ? item?.titleFontSizeMobile
                                    : 12,
                                fontWeight: item?.titleFontWeight
                                    ? item?.titleFontWeight
                                    : 600,
                                color: item?.titleColor
                                    ? item?.titleColor
                                    : colorMapping[ColorTokens.Grey_Night]
                            } }, item?.title)) : (
                        //@ts-ignore
                        React.createElement(Text, { style: {
                                fontSize: item?.titleFontSize
                                    ? item?.titleFontSize
                                    : 14,
                                fontWeight: item?.titleFontWeight
                                    ? item?.titleFontWeight
                                    : 600,
                                color: item?.titleColor
                                    ? item?.titleColor
                                    : colorMapping[ColorTokens.Grey_Night]
                            } }, item?.title))),
                    item?.subtitle &&
                        React.createElement(React.Fragment, null, _isMobile ? (
                        //@ts-ignore
                        React.createElement(Text, { style: {
                                fontSize: item?.subtitleFontSizeMobile
                                    ? item?.subtitleFontSizeMobile
                                    : 12,
                                fontWeight: item?.subtitleFontWeight
                                    ? item?.subtitleFontWeight
                                    : 600,
                                color: item?.subtitleColor
                                    ? item?.subtitleColor
                                    : colorMapping[ColorTokens.Secondary_100]
                            } }, item?.subtitle)) : (
                        //@ts-ignore
                        React.createElement(Text, { style: {
                                fontSize: item?.subtitleFontSize
                                    ? item?.subtitleFontSize
                                    : 14,
                                fontWeight: item?.subtitleFontWeight
                                    ? item?.subtitleFontWeight
                                    : 600,
                                color: item?.subtitleColor
                                    ? item?.subtitleColor
                                    : colorMapping[ColorTokens.Secondary_100]
                            } }, item?.subtitle))),
                    (item?.title ||
                        item?.subtitle) &&
                        React.createElement(Space, { size: _isMobile
                                ? SizeTypeTokens.XL
                                : SizeTypeTokens.XXXL })),
                (item?.primaryButtonLabel ||
                    item?.tertiaryButtonLabel) &&
                    React.createElement(View, { style: {
                            display: 'flex',
                            flexDirection: 'row',
                            width: '100%'
                        } },
                        item?.primaryButtonLabel &&
                            React.createElement(View, { style: {
                                    flex: 1,
                                    maxWidth: 200,
                                } },
                                React.createElement(Button, { label: item?.primaryButtonLabel, typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: _isMobile
                                        ? ButtonSizeDLS.SMALL
                                        : ButtonSizeDLS.MEDIUM, onPress: () => {
                                        item?.primaryRedirectUrl &&
                                            window.open(`${item?.primaryRedirectUrl}`, `${item?.primaryRedirectUrlTarget}`);
                                    } })),
                        item?.tertiaryButtonLabel &&
                            React.createElement(View, { style: {
                                    flex: 1,
                                } },
                                React.createElement(Button, { label: item?.tertiaryButtonLabel, typeDLS: ButtonTypeDLS.TERTIARY, sizeDLS: _isMobile
                                        ? ButtonSizeDLS.SMALL
                                        : ButtonSizeDLS.MEDIUM, onPress: () => {
                                        item?.tertiaryRedirectUrl &&
                                            window.open(`${item?.tertiaryRedirectUrl}`, `${item?.tertiaryRedirectUrlTarget}`);
                                    } }))),
                item?.footerTitle &&
                    React.createElement(View, null,
                        React.createElement(Space, { size: _isMobile ? SizeTypeTokens.SM : SizeTypeTokens.MD }),
                        _isMobile ? (
                        //@ts-ignore
                        React.createElement(Text, { style: {
                                fontSize: item?.footerTitleFontSizeMobile
                                    ? item?.footerTitleFontSizeMobile
                                    : 10,
                                fontWeight: item?.footerTitleFontWeight
                                    ? item?.footerTitleFontWeight
                                    : 400,
                                color: item?.footerTitleColor
                                    ? item?.footerTitleColor
                                    : colorMapping[ColorTokens.Grey_Charcoal]
                            } }, item?.footerTitle)) : (
                        //@ts-ignore
                        React.createElement(Text, { style: {
                                fontSize: item?.footerTitleFontSize
                                    ? item?.footerTitleFontSize
                                    : 12,
                                fontWeight: item?.footerTitleFontWeight
                                    ? item?.footerTitleFontWeight
                                    : 400,
                                color: item?.footerTitleColor
                                    ? item?.footerTitleColor
                                    : colorMapping[ColorTokens.Grey_Charcoal]
                            } }, item?.footerTitle)))),
            item?.imageUrl &&
                React.createElement(View, { style: {
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'flex-end'
                    } },
                    React.createElement(Image, { size: ImageSizeTokens.SIZE_22, uri: item?.imageUrl, height: item?.imageHeight
                            ? _isMobile ? item?.imageHeightMobile
                                : item?.imageHeight
                            : 106, width: item?.imageWidth
                            ? _isMobile ? item?.imageWidthMobile
                                : item?.imageWidth
                            : 95 }))),
        index <= data?.length - 2 &&
            React.createElement(Space, { size: _isMobile
                    ? SizeTypeTokens.XL
                    : SizeTypeTokens.XXXL })))))), [data]);
    if (data &&
        data.length > 1) {
        return (React.createElement(View, { style: {
                width: '100%'
            } },
            React.createElement(ScrollView, { style: {
                    flex: 1
                }, horizontal: true, showsHorizontalScrollIndicator: false, showsVerticalScrollIndicator: false }, renderCardItems)));
    }
    return (React.createElement(React.Fragment, null, renderCardItems));
};
export default memo(PartnerPromotionCards);
export { PartnerPromotionCards };
